import React from 'react';
import styled from 'styled-components';
import Modal_button from '../modal/Modal_button';


export default function Modal_inner(props) {

    return (
       
            props.showModal ? 
            <div>
                <Modal_bg ></Modal_bg>
                <Modal>
                    <Modal_title>{props.title}</Modal_title>
                        <Modal_content_inner>{props.subtitle}</Modal_content_inner>
                    <Modal_button setShowModal={props.setShowModal} submitClick={props.submitClick}/>
                </Modal>
            </div>
            :
            null

        
    )
}



const Modal = styled.div`
    position: fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    width: calc(100vw*(284/375));
    border-radius: calc(100vw*(10/375));
    background-color: #ffffff;
    z-index: 500;
`
const Modal_title = styled.h3`
    font-size: calc(100vw*(18/375));
    font-weight: bold;
    letter-spacing: 0.25px;
    text-align: center;
    padding: calc(100vw*(20/375)) 0 calc(100vw*(12/375)) 0;
`
const Modal_content_inner = styled.p`
    text-align: center;
    font-size: calc(100vw*(14/375));
    line-height: 1.43;
    letter-spacing: 0.2px;
    padding-bottom: calc(100vw*(16.5/375));
`

const Modal_bg = styled.div`
    position: fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.6);
    z-index: 400;
`